<template>
  <div class="page" ref="scrollPage">
    <Header theme="white" @setScroll="setScroll"></Header>
    <!---轮播图 start-->
    <div class="wrapper" id="home">
      <!-- <swiper ref="mySwiper" :options="swiperOptions"> -->
        <!-- <swiper-slide> -->
          <div class="bannerWrap bannerWrap8">
          </div>
        <!-- </swiper-slide> -->
       <!-- <swiper-slide>
          <div class="bannerWrap bannerWrap9">
            <div class="zly-name">CQM方圆“质量月”</div>
            <div class="zly-btn" @click="toZLY">了解质量月</div>
          </div>
        </swiper-slide> -->
        <div class="swiper-pagination" slot="pagination"></div>
      <!-- </swiper> -->
    </div>
    <!---轮播图 end-->
    <!--应用市场-->
    <!-- <div v-if="titleList.length > 0" style="display: none;" v-for="(item, index) in titleList" :key="index" class="talentService" :id="item.id" :ref="item.id">{{item.id}}</div> -->
    <div style="display: none;" class="talentService" id="27" ref="28"></div>
    <div style="display: none;" class="talentService" id="28" ref="28"></div>
    <div style="display: none;" class="talentService" id="29" ref="29"></div>
    <div style="display: none;" class="talentService" id="30" ref="30"></div>
    <div style="display: none;" class="talentService" id="31" ref="31"></div>
    <div style="display: none;" class="talentService" id="33" ref="33"></div>
    <!-- <div class="talentService" id="talent" ref="talent">
      <div class="wrapTit pb70">
        应用市场
      </div>
      <div class="talentBody">
        <img class="sc_icon" src="../assets/images/sc@2x.png" alt="" srcset="" />
        <div class="sccontent">
          <div v-for="(item, index) in yyData.slice(0, 9)" :key="index">
            <div class="sctitle">
              <img :src="baseURL + item.logo" alt="" srcset="" />
              <div>{{item.title}}</div>
            </div>
            <div class="scinfo" v-for="(item1,index) in item.typeName" :key="index">{{item1}}</div>
            <div class="scdetails" @click="goYYDetail(item.id)">查看详情 》</div>
          </div>
        </div>
      </div>
      <div class="moreCP" @click="goMoreApp">更多产品</div>
    </div> -->
    <!--解决方案亮点-->
    <!-- <div class="zcInformation" id="zcInformation" ref="zcInformation">
      <div class="zcInner">
        <div class="zcTit">解决方案亮点</div>
        <div class="faldList">
          <div @click="tabFA(index)" :class="{'faldList_item1' : faindex == index}" class="faldList_item"
            v-for="(item, index) in jjfaList" :key="index">{{item.topTitle}}</div>
        </div>
        <div class="facontent">
          <img class="sbzt" :src="baseURL + jjfaList[faindex].subImage" alt="" srcset="" />
          <div>
            <div class="fatitle">{{jjfaList[faindex].topTitle}}</div>
            <div class="fainfo">{{jjfaList[faindex].solutionText}}</div>
            <div class="fabtns">
              <div @click="toDetails(jjfaList[faindex].id)">查看详情</div>
              <div @click="toSolutionList">查看更多产品</div>
            </div>
          </div>
        </div>
      </div>
    </div> -->


    <!--信息安全-->
    <!-- <div class="safe" id="safe" ref="safe">
      <div class="safetitle">
        标识解析
      </div>
      <div
        style="width: 1300px;margin: 30px auto 0;display: flex;justify-content: space-between; align-items: center;;">
        <div style="width: 680px;">
          <div
            style="font-size: 24px;font-family: PingFang SC;font-weight: 500;color: #121E30;line-height: 36px;margin: 120px 0 30px;">
          </div>
          <div>
            <div v-for="(item, index) in AnalysisData[0].array" :key="index"
              style="display: flex;justify-content: flex-start;padding: 5px 0 10px 0;">
              <div style="line-height: 32px;margin-right: 10px;">
                <img src="../assets/images/zsline.png" style="width: 10px;height: 12px;" />
              </div>

              <div style="font-size: 16px;font-family: PingFang SC;font-weight: 500;color:#1E1E1E;line-height: 32px;">
                {{item}}
              </div>
            </div>

          </div>
          <div class="qysjd" @click="goSjd">企业上节点</div>

        </div>
        <img :src="baseURL + AnalysisData[0].logo" style="width: 618px; margin-left: 50px;">
      </div>
    </div> -->
    <!-- 开放服务 -->
    <div class="service" id="open" ref="open">
      <div class="gyTit">关于我们</div>
      <div
        style="width: 1300px;margin: 30px auto 0;display: flex;justify-content: space-between; align-items: center;;flex-direction: column;">
        <div class="gycontent">
          <!-- <span style="font-weight: bold;">方圆标志认证集团</span>（China Quality Mark Certification
          Group，英文缩写CQM）起步于1991年，由“中国方圆标志认证委员会”发展演变而来，在引入和奠基中国认证制度的同时，与我国认证认可事业共同成长，是集认证、培训、科研、政策研究、标准制定、国际合作于一体，面向全球的集团化、专业性技术服务机构。 -->
          {{aboutUsData.contentTitle}}
        </div>
        <img class="gywmbg" :src="baseURL + aboutUsData.image" alt="" srcset="" />
        <div class="gycontent1">
          <div>
            <div v-for="(item, index) in aboutUsData.array" :key="index">
              {{item}}
            </div>
          </div>
          <div class="gywmright">
            <img class="glogo" :src="baseURL + aboutUsData.logo" alt="" srcset="" />
          </div>
        </div>
      </div>

    </div>

    <!-- <MarketDialog :dialogData='dialogData' @valueData="childrenData"></MarketDialog>
    <PlatformDialog :dialogData='dialogData1' @valueData="childrenData1"></PlatformDialog> -->
    <!-- <serviceDialog :dialogData='dialogData2' @valueData="childrenData2"></serviceDialog> -->
    <!--页脚-->
    <Footer @setScroll="setScroll" />
    <!-- 动态飘窗 -->
   <!-- <div class="home">
      <Baywindow></Baywindow>
    </div> -->
  </div>
</template>
<script>
  import {
    getStatus,
    getLogout,
    getJJFAData,
    getArticleData,
    getApplicationData,
    ecology,
    contentByType,
    getAboutUs,
    fetchAllCategory
  } from '@/api/api'
  import {
    serverUrl
  } from '@/utils/server.js'
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import MarketDialog from '@/components/marketDialog.vue'
  import PlatformDialog from '@/components/PlatformDialog.vue'
  import serviceDialog from '@/components/serviceDialog.vue'
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper";
  import "swiper/swiper-bundle.css";
  import countTo from "vue-count-to"
  let vm;
  import Baywindow from './Baywindow.vue'
  export default {
    data() {
      return {
        titleList: [],
        yyData: [],
        aboutUsData: {},
        AnalysisData: null,
        faldContent: [{
          title: '设备状态监测',
          content: '通过工业互联网标识解析体系为设备及关键部件分配唯一标识，并将传感采集设备与标识绑定，设备运行过程中，传感器 通过主动标识技术，实时发送设备的运行数据，反馈至设备监测系统后进行数据分析、阈值判断、状态预警，并通过数据可视 化展示。设备状态异常时，通过主动标识实时定位异常位置，通过系统导航维修人员快速抵达。针对不同用户，通过同一标识 所获取的数据信息和管理权限不同，实现设备分级管理。'
        }, {
          title: '防伪系统管理',
          content: '通过工业互联网标识解析体系为产品分配唯一标识，消费者可通过手机扫码的方式进行正品验证。同时，企业可实时获知产品的扫码地点与时间，对产品的销售情况做分析，进而优化销售策略。标识具有唯一性，且一物一码，结合涂层等手段，可大大提高仿冒产品的作假成本，通过扫码大数据的分析，也可以...'
        }, {
          title: '智能产品全生命周期管理',
          content: '企业通过工业互联网标识解析体系，从产品订单生成开始便赋予唯一标识，该标识贯穿始终，从研发设计、生产计划、 材料供应，到产品生产、订单交付，再到售后服务、最终报废，各个环节的信息都关联到该标识上，从而实现产品全生命周期管理。通过对标识汇聚的各个生产环节的生产数据进行统计分析，可以实现生产环节的能效分析、故障定位，逬而生成调优策略，优化产线配置，提升生产效率和质量。'
        }],
        scList: [{
          name: '供应商评估',
          info: '供应商管理'
        }, {
          name: '二方审核',
          info: '供应商管理'
        }, {
          name: '制造业质量能力评估',
          info: '质量提升'
        }, {
          name: '合规管理体系评价',
          info: '管理体系'
        }, {
          name: '内审管理',
          info: '供应商管理'
        }, {
          name: '产品溯源系统',
          info: '市场管控'
        }, {
          name: '设备智能巡检系统',
          info: '设备管理'
        }, {
          name: '客户体验满意度调查',
          info: '客户体验'
        }, {
          name: '渠道防窜货管理系统',
          info: '市场管控'
        }],
        faindex: 0,
        faldList: [{
          name: '设备状态监测'
        }, {
          name: '防伪系统管理'
        }, {
          name: '智能产品全生命周期管理'
        }],
        ecologyData: {
          applicationNum: 0,
          customerNum: 0,
          enterpriseNum: 0
        },
        dialogData: false,
        dialogData1: false,
        dialogData2: false,
        timer: null, // countToTimer
        baseURL: serverUrl.baseURL,
        itemList: [],
        scroll: 'home',
        dialogVisible: false,
        itemVal: {},
        dynamicActive: 0,
        dynamicData: [

        ],
        flag: false,
        activeIndex: 2,
        username: '',
        activeSC: 1,
        activeName: '1',
        policyList: [

        ],
        active: 1,
        val: '',
        finalList: [{
          name: '碳效码',
          content: '实现工业企业碳效查询“一码了然”'
        }, {
          name: '唐久码',
          content: '为酒企定制了数字化全链路营销方案及工具'
        }, {
          name: '日化标识码',
          content: '沉淀私域流量、裂变营销获客必备神器'
        }],
        // 解决方案
        jjfaList: [],
        swiperOptions: {
          slidesPerView: 1,
          loop: true,
          speed: 2000,
          autoplay: {
            delay: 3000,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
          // 显示分页
          pagination: {
            el: ".swiper-pagination",
            clickable: true, //允许分页点击跳转
          },
          // 设置点击箭头
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        },
        // 应用市场
        swiperOption2: {
          // 可见图片张数
          slidesPerView: 3,
          // 默认选中中间一张
          centeredSlides: false,
          centeredSlidesBounds: true,
          // 无限循环
          loop: true,
          // effect: 'coverflow',
          // 小圆点（我此处没使用，列出供参考）
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          coverflow: {
            rotate: 0, // slide做3d旋转时Y轴的旋转角度。默认50。
            stretch: 200, // 每个slide之间的拉伸值，越大slide靠得越紧。 默认0。
            depth: 150, // slide的位置深度。值越大z轴距离越远，看起来越小。 默认100。
            // modifier: 1, // depth和rotate和stretch的倍率，相当于depth*modifier、rotate*modifier、stretch*modifier，值越大这三个参数的效果越明显。默认1。
            slideShadows: false // 开启slide阴影。默认 true。
          },
          // 自动轮播
          autoplay: {
            stopOnLastSlide: true,
            delay: 1000
          },
          // 上下按钮点击轮播效果
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
          },
          on: {
            click: function(e) {
              console.log('---', e.target.id)
              console.log(e)
              let id = e.target.id
              if (id) {
                vm.goYYDetail(id)
              }
            }
          }
        },
      }
    },
    components: {
      Baywindow,
      Header,
      Footer,
      swiper,
      swiperSlide,
      countTo,
      MarketDialog,
      PlatformDialog,
      serviceDialog
    },
    mounted() {
      this.getCategory()
      // 应用市场数据
      this.$nextTick(() => {
        this.getYYData()

      })

    },
    created() {
      vm = this
      var user = JSON.parse(localStorage.getItem('fyuser'))
      if (user && user.username) {
        this.username = user.username
      }
      window.addEventListener('scroll', this.handleScroll1)
      this.getJJFAList()
      this.getAnalysis()
      this.setAboutUs()

    },
    computed: {
      seamlessScrollOption() {
        return {
          step: 1, // 数值越大速度滚动越快
          limitMoveNum: this.yyData.length, // 开始无缝滚动的数据量 this.dataList.length
          hoverStop: true, // 是否开启鼠标悬停stop
          direction: 2, // 0向下 1向上 2向左 3向右
          openWatch: true, // 开启数据实时监控刷新dom
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 1000, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
        };
      },
    },
    methods: {
      getCategory() {
        fetchAllCategory().then(res => {
          this.titleList = res.data
          console.log('----------------------------', res)
        })
      },
      goMoreApp() {
        this.$router.push({
          path: "/appList"
        })
      },
      goYYDetail(id) {
        this.$router.push({
          path: "/marketdetails",
          query: {
            data: id
          },
        })
      },
      setAboutUs() {
        getAboutUs().then(res => {
          this.aboutUsData = res.data
        })
      },
      getAnalysis() {
        let params = {
          type: 2
        }
        contentByType(params).then(res => {
          this.AnalysisData = res.data
        })
      },
      getJJFAList() {
        let params = {
          indexShow: 1,
          page: 0,
          size: 3,
        }
        getJJFAData(params).then(res => {
          this.jjfaList = res.data.content
        })
      },
      getYYData() {
        let params = {
          page: 0,
          size: 10,
        }
        getApplicationData(params).then(res => {
          // let data = res.data.content
          // this.yyData = this.handleArr(data)
          this.yyData = res.data.content
          this.yyData.map(item => {
            item.typeName = item.typeName.split(",")
          })
        })
      },
      handleArr(data) {
        var result = [];
        for (var i = 0, len = data.length; i < len; i += 2) {
          result.push(data.slice(i, i + 2));
        }
        return result
      },
      toZLY() {
        this.$router.push({
          path: "/ZLYList"
        })
      },
      toSolutionList() {
        this.$router.push({
          path: "/SolutionList"
        })
      },
      toDetails(val) {
        this.$router.push({
          path: "/DetailsPage",
          query: {
            data: val
          },
        })
      },
      tabFA(index) {
        this.faindex = index
      },
      goSjd() {
        this.$router.push({
          path: '/UpperNode'
        })
      },
      // 应用市场处理数字
      getNum(number) {
        if (!number && number != 0) return number;
        var str_num
        if (number >= 1E3 && number < 1E4) {
          str_num = number / 1E3
          return str_num + '千'
        } else if (number >= 1E4 && number < 1E6) {
          str_num = number / 1E4
          return str_num + '万'
        } else if (number >= 1E6 && number < 1E7) {
          str_num = number / 1E6
          return str_num + '百万'
        } else if (number >= 1E7 && number < 1E8) {
          str_num = number / 1E7
          return str_num + '千万'
        } else if (number >= 1E8 && number < 1E10) {
          str_num = number / 1E8
          return str_num + '亿'
        } else if (number >= 1E10 && number < 1E11) {
          str_num = number / 1E10
          return str_num + '百亿'
        } else if (number >= 1E11 && number < 1E12) {
          str_num = number / 1E11
          return str_num + '千亿'
        } else if (number >= 1E12) {
          str_num = number / 1E12
          return str_num + '万亿'
        } else { //一千以下
          return number
        }
      },
      setScroll(eId) {
        console.log('123', eId)
        localStorage.setItem('eId', eId)
        if (Number(eId)) {
          this.$router.push({
            path: "/appList"
          })
        } else {
          this.scroll = eId
          let dis = document.getElementById(eId).offsetTop
          // let dis = this.$refs[eId].getBoundingClientRect().top
          window.scrollTo({
            top: dis - 115,
            left: 0,
            behavior: "smooth"
          });
        }

      },
      handleScroll1() {
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        // console.log(scrollTop, '滚动距离')
        if (scrollTop > 0) {
          this.flag = true
        } else {
          this.flag = false
        }
      },
      toLogin() {
        this.$router.push({
          path: '/login'
        })
      },
      setLogin() {
        getLogout().then(res => {
          localStorage.removeItem('fyuser')
          this.$router.push({
            path: '/login'
          })
        }).catch(err => {
          localStorage.removeItem('fyuser')
          this.$router.push({
            path: '/login'
          })
        })
      },
      handleScroll(id, index) {
        // this.activeIndex = index
        var element = document.getElementById(id);
        this.scroll = element.id
        console.log('==========' + this.scroll)
        element.scrollIntoView({
          behavior: "smooth",
          block: "nearest",
          inline: "nearest"
        })

      },
    }
  }
</script>
<style scoped>
  @media screen and (max-width:1900px) {
    .zly-name {
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 48px;
      color: #FFFFFF;
      line-height: 99px;

    }

    .zly-btn {
      width: 200px;
      height: 62px;
      background: #FFA800;
      border-radius: 38px;

      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 28px;
      color: #002071;

      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 5%;
      cursor: pointer;
    }
  }

  @media screen and (min-width:1900px) {
    .zly-name {
      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 86px;
      color: #FFFFFF;
      line-height: 99px;

    }

    .zly-btn {
      width: 236px;
      height: 76px;
      background: #FFA800;
      border-radius: 38px;

      font-family: Source Han Sans CN;
      font-weight: bold;
      font-size: 28px;
      color: #002071;

      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 5%;
      cursor: pointer;
    }
  }
  .titleName {
    display: flex;
    align-items: center;
    justify-content: center;
    /* margin: 0 10px; */
    cursor: pointer;
    padding: 0 5px;
  }

  .page {
    width: 100%;
    overflow-x: hidden;
  }


  .bs_bj {
    width: 1373px;
    height: 240px;
    background: url('../assets/images/bs_bj@2x.png') top left no-repeat;
    background-size: cover;
    text-align: center;
  }

  .marketList>div {
    cursor: pointer;
  }

  .final {
    position: relative;
    width: 100%;
    height: 840px;
    background: url('../assets/images/jjfabg@2x.png') top left no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
  }

  .platform {
    width: 100%;
    height: 840px;
    box-sizing: border-box;
    /* background: url('../assets/images/gx@2x.png') top center no-repeat; */
    background-size: 100% 1200px;
    background-image: url('../assets/images/gx_bj2@2x.png');
  }

  .finance {
    width: 100%;
    height: 840px;
    box-sizing: border-box;
    background: linear-gradient(183deg, #F0F6FF, #FFFFFF);
    padding: 88px 0;
  }

  .policy {
    width: 100%;
    height: 840px;
    box-sizing: border-box;
    background: url('../assets/images/zcbj@2x.png') top left no-repeat;
    background-size: 100% 100%;
    padding: 88px 0;
  }

  .one {
    width: 919px;
    height: 500px;
    display: flex;
    align-items: center;
    padding: 0 76px;
    /* flex-direction: column; */
  }

  .one {
    box-sizing: border-box;
    background: url('../assets/images/txm@2x.png') top left no-repeat;
    background-size: cover;
  }

  .two {
    box-sizing: border-box;
    /* background: url('../assets/images/tjm_bj@2x.png') top left no-repeat; */
    /* background: linear-gradient(183deg, #FFFFFF, #F2F7FF); */
    /* background-size: cover; */
  }

  .three {
    box-sizing: border-box;
    background: url('../assets/images/rhm_t@2x.png') top left no-repeat;
    background-size: cover;
  }

  .one .content,
  .two .content,
  .three .content {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 26px;
    margin: 52px 0 27px;
    width: 765px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .line {
    margin: 40px auto 0;
    width: 1214px;
    height: 12px;
    /* background: url('../assets/images/jt@2x.png') top left no-repeat; */
    background-image: linear-gradient(to right, #DFE9FF 5%, #53A6FF 99%, #DFE9FF);
    background-size: cover;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    position: relative;
  }

  .policy .content {
    text-overflow: -o-ellipsis-lastline;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    line-clamp: 4;
  }

  .policy .item:hover {
    background-color: #fff !important;
  }

  .policy .item:hover .trangle {
    position: absolute;
    bottom: -10px;
    left: 170px;
    width: 0;
    height: 0;
    border-top: 10px solid #fff !important;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;
  }

  .dynamic {
    width: 100%;
    height: 840px;
    box-sizing: border-box;
    background: url('../assets/images/dtbj@2x.png') top left no-repeat;
    background-size: cover;
    padding: 88px 0;
  }

  .dynamicLeft {
    width: 475px;
    height: 547px;
    box-sizing: border-box;
    background: url('../assets/images/dt@2x.png') top left no-repeat;
    background-size: cover;
    padding: 30px;
    cursor: pointer;
  }

  /deep/ .el-tabs__nav-wrap::after {
    background-color: #fff
  }

  /deep/ .el-tabs__item {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #121E30;
  }

  /deep/ .el-tabs__active-bar {
    background-color: #0478ED;
  }

  .dynamicActive1 {
    background: #FFFFFF;
    box-shadow: 6px 6px 16px 0px #EAEDF2;
    border-radius: 10px;
  }

  .service {
    width: 100%;
    height: 840px;
    box-sizing: border-box;
    background: url('../assets/images/gywm_bj@2x.png') top left no-repeat;
    background-size: cover;
    padding: 40px 0;
  }

  .Internet {
    width: 100%;
    height: 840px;
    box-sizing: border-box;
    background: url('../assets/images/ny@2x.png') top left no-repeat;
    background-size: cover;
    padding: 88px 0;
  }

  .scOne:hover,
  .scTwo:hover,
  .scThree:hover,
  .scFour:hover,
  .scFive:hover,
  .scSix:hover,
  .scSeven:hover {
    background: #0D65FF !important;
  }

  .scOne:hover .content,
  .scOne:hover .content,
  .scTwo:hover .content,
  .scThree:hover .content,
  .scFour:hover .content,
  .scFive:hover .content,
  .scSix:hover .content,
  .scSeven:hover .content {
    color: #9ABFFF !important;
  }

  .scOne:hover .left {
    top: 85px !important;
    left: 105px !important;

  }

  .scOne:hover .right {
    top: 70px;
    left: 140px !important;
  }

  .scTwo:hover .left,
  .scTwo:hover .left,
  .scThree:hover .left,
  .scFour:hover .left,
  .scFive:hover .left,
  .scSix:hover .left,
  .scSeven:hover .left {
    top: 60px !important;
    left: 105px !important;
  }

  .scTwo:hover .right,
  .scTwo:hover .right,
  .scThree:hover .right,
  .scFour:hover .right,
  .scFive:hover .right,
  .scSix:hover .right,
  .scSeven:hover .right {
    top: 30px;
    left: 140px !important;
  }

  .trangle {
    position: absolute;
    bottom: -10px;
    left: 170px;
    width: 0;
    height: 0;
    border-top: 10px solid #ECF2FF;
    border-right: 10px solid transparent;
    border-left: 10px solid transparent;

  }

  .item11,
  .item22 {
    width: 240px;
    display: none !important;
  }

  .item1:hover .item11 {
    display: block !important;
  }

  .item2:hover .item22 {
    display: block !important;
  }

  .item3:hover .item33 {
    display: block !important;
  }

  .item11>div,
  .item22>div {
    width: 80px;
  }

  .item33 {
    width: 480px;
    display: none !important;
  }

  .item33>div {
    width: 200px;
  }

  /***轮播图 */
  .swiper-container {}

  .swiper-slide {
    height: 1080px;
  }

  .swiper-pagination>>>.swiper-pagination-bullet {
    width: 64px;
    height: 4px;
    background: #0f1c85;
    border-radius: 0;
    opacity: 1;
  }

  .wrapper>>>.swiper-container-horizontal>.swiper-pagination-bullets {
    bottom: 120px;
    left: 15%;
    width: inherit;
  }

  .swiper-pagination>>>.swiper-pagination-bullet.swiper-pagination-bullet-active {
    background: rgba(15, 77, 255, 1)
  }

  /** 首页样式 */
  .two {
    height: 840px;
    background: linear-gradient(183deg, #F0F6FF, #FFFFFF);
    box-sizing: border-box;
    padding: 88px 0 123px;
  }


  .jjfaLeftItem {
    width: 359px;
    height: 110px;
    display: flex;
    align-items: center;
    padding-left: 40px;
    position: relative;
    cursor: pointer;
    position: relative;
    margin-bottom: 20px;
  }

  .jjfaLeftItemTit {
    font-size: 24px;
    font-family: PingFang SC;
    color: #8695AE;
    line-height: 36px;
  }

  .jjfaLeftItemSubTit {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #8695AE;
    line-height: 26px;
  }

  .jjfaLeftItem .activeArrow {
    width: 0;
    height: 0;
    border-left: 7px solid #fff;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    display: block;
    position: absolute;
    top: 23px;
    left: 20px;
    display: none;
  }

  .jjfaLeftItem:hover {
    background: linear-gradient(90deg, #3275F2, rgba(70, 66, 69, 0));
  }

  .jjfaLeftItem:hover .activeArrow {
    display: block;
  }

  .jjfaLeftItem:hover .jjfaLeftItemTit {
    color: #fff;
  }

  .jjfaLeftItem:hover .jjfaLeftItemSubTit {
    color: #fff;
  }

  .jjfaLeftItem.active {
    background: linear-gradient(90deg, #3275F2, rgba(70, 66, 69, 0));
  }

  .jjfaLeftItem.active .jjfaLeftItemTit {
    color: #fff;
  }

  .jjfaLeftItem.active .jjfaLeftItemSubTit {
    color: #fff;
  }

  .jjfaLeftItem.active .activeArrow {
    display: block;
  }

  .jjfaRightBlock {
    width: 886px;
    height: 416px;
    border-radius: 20px;
    box-sizing: border-box;
    padding-left: 64px;
    padding-top: 88px;
    padding-right: 64px;
    margin-left: 77px;
  }

  .jjfaRightBlock .jjfaRightTit {
    font-size: 24px;
    font-weight: bold;
    color: #fff;
    margin-bottom: 50px;
  }

  .jjfaRightBlock .content {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 30px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
  }

  .moreBtn {
    width: 134px;
    height: 46px;
    border: 1px solid #FFFFFF;
    /* box-shadow: 0px 3px 10px 0px rgba(127,166,214,0.73); */
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    line-height: 46px;
    cursor: pointer;
    margin-top: 40px;
  }

  .yyscWrap {
    height: 890px;
    background: linear-gradient(0deg, #ECF4FF, #FFFFFF);
  }

  .wrapTit {
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #121E30;
    text-align: center;
    padding-top: 88px;
    padding-bottom: 160px;
  }

  .wrapSubTit {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #121E30;
  }

  .yyscWrapBody {
    width: 1373px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .yyscImg {
    width: 525px;
  }

  .yyscLeft {
    margin-right: 50px;
  }

  .yyscLeft .yyscSubTit {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #121E30;
  }

  .yyscLeft .yyscContent {
    padding-top: 47px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #516381;
    line-height: 26px;
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
  }

  .yyscLeft .cirIcon {
    width: 10px;
    margin-right: 9px;
  }

  .cirIcon span {
    padding-right: 180px;
  }

  .yyListWrap {
    width: 790px;
    height: 280px;
    background: linear-gradient(90deg, #D4E5FF, rgba(245, 249, 255, 0.01));
    border-radius: 20px 0px 0px 20px;
    box-sizing: border-box;
    padding: 40px 10px;
    overflow: hidden;
    /* display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: nowrap; */
    position: relative;
  }

  .yyScrollIWraper {
    /* width: 1610px; */
    /* border: 1px solid #f00; */
  }

  .yyScrollItem {
    float: left;
  }

  .yyItemBox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
    width: 230px;
    height: 100px;
    box-sizing: border-box;
    padding-left: 20px;
    /* border: 1px solid #f00; */
  }

  .yyItemBox .iconImg {
    width: 65px;
    margin-right: 10px;
  }

  .yyItemBox .itemName {
    font-size: 22px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #353B46;
    line-height: 36px;
  }

  .yyItemBox .itemCont {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #A3ADC0;
    line-height: 31px;
  }

  .yyItemBox .itemCont span {
    color: #2178E3;
    font-size: 16px;
    font-weight: bold;
  }

  .wrapDotImg {
    width: 87px;
    bottom: -30px;
    left: 56px;
    position: absolute;
    /* border: 1px solid #f00; */
  }

  .wrapTit2 {
    color: #fff;
  }

  .pb140 {
    padding-bottom: 140px;
  }

  .platformBody {
    width: 1373px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0 auto;
  }

  .platformBody .leftImg {
    width: 500px;
    margin-right: 120px;
  }

  .platformItem {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .platformItem .itemCont {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(18, 30, 48, 1);
    line-height: 50px;
  }

  .btnsBox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .blueBtn {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    padding: 8px 30px;
    background: #2B69E7;
    border-radius: 23px;
    border: 1px solid #2B69E7;
    cursor: pointer;
  }

  .whiteBtn {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(43, 105, 231, 1);
    padding: 8px 30px;
    background: transparent;
    border-radius: 23px;
    border: 1px solid rgba(43, 105, 231, 1);
    cursor: pointer;
  }

  .platformBody .btnsBox {
    padding-top: 70px;
  }

  .mr23 {
    margin-right: 23px;
  }

  .pb107 {
    padding-bottom: 107px;
  }

  .dataService {
    background: url('../assets/images/dataBg.png') top center no-repeat;
    width: 100%;
    height: 840px;
    background-size: 100% 100%;
  }

  .dataBody {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    width: 1373px;
  }

  .dataImg {
    width: 659px;
    height: 273px;
  }

  .dataImgWrap {
    width: 659px;
    height: 273px;
    position: relative;
  }

  .dataImgWrap .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .dataImgWrap:hover .mask {
    display: none;
  }

  .dataMsg {
    padding-left: 32px;
    padding-top: 42px;
  }

  .dataMsg .topTit {
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
  }

  .dataMsg .con {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #A3ADC0;
    line-height: 36px;
    width: 630px;
  }

  .pb120 {
    padding-bottom: 120px;
  }

  .pb70 {
    padding: 70px 0;
  }

  .talentService {
    height: 840px;
    background: linear-gradient(0deg, #E9ECF5, #FFFFFF);
  }

  .talentBody {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .talentCard {
    width: 416px;
    height: 470px;
    background: #FFFFFF;
    box-shadow: 0px 7px 51px 0px #DCE4EC;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .diImg {
    width: 320px;
  }

  .cardTit {
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #121E30;
    line-height: 36px;
    margin: 30px 0 50px;
  }

  .cardCon {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #516381;
    line-height: 36px;
    text-align: center;
    padding: 0 18px;
  }

  .aniBox {
    height: 180px;
    width: 200px;
    position: relative;
  }

  .aniBox .aniImg1 {
    width: 131px;
    height: 132px;
    position: absolute;
    left: 20px;
    top: 30px;
    z-index: 2;
    transition: all 0.5s linear;
  }

  .aniBox .aniImg2 {
    width: 131px;
    height: 132px;
    position: absolute;
    left: 40px;
    top: 20px;
    z-index: 1;
    transition: all 0.5s linear;
  }

  .talentCard {
    margin: 0 22px;
  }

  .talentCard:hover .aniImg1 {
    left: 0;
    top: 40px
  }

  .talentCard:hover .aniImg2 {
    left: 60px;
    top: 10px;
  }

  .ecologyWrap {
    height: 840px;
    background: url('../assets/images/st@2x.png') top center no-repeat;
  }

  .ecoBlock1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1000px;
    margin: 0 auto;

  }

  .ecoBox {
    text-align: center;
  }

  .ecoTit {
    font-size: 54px;
    font-family: DIN;
    font-weight: 500;
    color: #FFFFFF;
    width: 300px;
    text-align: center;
  }

  .ecoSubTit {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #78A2FF;
    line-height: 30px;
  }

  .ecoBlock2 {
    width: 1340px;
    height: 370px;
    background: rgba(255, 255, 255, 0.3);
    margin: 65px auto 0;
    border-radius: 20px;
  }

  .ecoBlock2 .tit {
    font-size: 30px;
    font-family: PingFang SC;
    color: #FFFFFF;
    text-align: center;
    padding: 50px 0 40px;
  }

  .ecoContent {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 33px;
  }

  .ecoContent p {
    text-indent: 2rem;
    margin: 0;
    padding: 0 75px;
  }

  .bannerWrap {
    width: 100%;
    height: 1080px;
    position: relative;
    /* background: #f00; */
  }

  .bannerWrap1 {
    background: url('../assets/images/banner1.jpg') top center no-repeat;
    background-size: cover;
  }

  .bannerWrap2 {
    background: url('../assets/images/banner2.jpg') top center no-repeat;
    background-size: cover;
  }

  .bannerWrap3 {
    background: url('../assets/images/banner3.jpg') top center no-repeat;
    background-size: cover;
  }

  .bannerWrap4 {
    background: url('../assets/images/banner4.jpg') top center no-repeat;
    background-size: cover;
  }

  .bannerWrap5 {
    background: url('../assets/images/banner5.jpg') top center no-repeat;
    background-size: cover;
  }

  .bannerWrap6 {
    background: url('../assets/images/banner6.jpg') top center no-repeat;
    background-size: cover;
  }

  .bannerWrap7 {
    background: url('../assets/images/banner07.png') top center no-repeat;
    background-size: cover;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-left: 8%;
  }

  .bannerWrap8 {
    height: 100vh;
    background: url('../assets/images/banner8.jpg') top center no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
  }

  .bannerWrap9 {
    height: 100vh;
    background: url('../assets/images/banner9.png') top center no-repeat;
    background-size: 100% 100%;
    /* display: flex; */
    /* align-items: center; */
    /* flex-direction: column; */
    /* justify-content: center; */
    box-sizing: border-box;
    padding-left: 6%;
    padding-top: 20%;
  }

  .banner07 {
    width: 620px;
    height: 320px;
  }

  .bannerWrap .leftContnet {
    width: 45%;
    padding-top: 380px;
    padding-left: 45px;
  }

  .bannerWrap .leftContnet .bigTit {
    font-size: 70px;
    font-family: PingFang SC;
    color: #fff;
  }

  .bannerWrap .leftContnet .subTit {
    font-size: 50px;
    font-family: PingFang SC;
    color: #fff;
    padding-top: 10px;
  }

  .info {
    font-family: PingFang SC;
    color: #fff;
    font-size: 20px;
    padding-top: 58px;
    line-height: 30px;
  }

  .bannerBtn {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    padding: 10px 30px;
    border: 1px solid #FFFFFF;
    border-radius: 28px;
    position: absolute;
    bottom: 260px;
    left: 15%;
  }

  .gyzxImgBox {
    width: 400px;
    height: 204px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
  }

  .gyzxImgBox img {
    width: 100%;
    height: 100%;
  }

  .nodeTit {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #7A89A2;
  }

  .nodeTit.active {
    color: #0C67D8;
    position: relative;
  }

  .nodeTit.active::after {
    display: block;
    content: "";
    width: 215px;
    height: 2px;
    background: #0C67D8;
    position: absolute;
    bottom: -31px;
    left: 50%;
    transform: translateX(-50%);
  }

  .jjfaMoreBtn {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: left;
    padding-left: 40px;
    cursor: pointer;
  }

  .pb80 {
    padding-bottom: 80px;
  }

  .line3 {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #516381;
    line-height: 27px;
    margin-top: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    word-break: break-all;
  }

  .dynamicItem:hover {
    background: #fff;
    box-shadow: 6px 6px 16px 0px #EAEDF2;
    border-radius: 10px;
  }

  .datasWrap {
    background: #0C1728;
    box-shadow: 0px 7px 27px 0px #16171A;
    border-radius: 20px;
    width: 659px;
    overflow: hidden;
    padding-bottom: 38px;
  }

  .policy .zcBox {
    position: relative;
  }

  .policy .zcBox:hover::after {
    border-top: 10px solid #fff;
  }

  .policy .zcBox::after {
    display: block;
    content: "";
    width: 0;
    height: 0;
    border-top: 10px solid rgb(236, 242, 255);
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    display: block;
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
  }

  /* .policy .content
    display: block;
    content: "";
    width: 0;
    height: 0;
    border-left: 7px solid #f00;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    display: block;
    position: absolute;
    top: 23px;
    left: 20px;
    display: none;
  } */
  .flagWrap {
    /* border: 1px solid #f00; */
    position: absolute;
    width: 800px;
    height: 610px;
    bottom: 150px;
    right: 10px;
  }

  .flagBox {
    position: absolute;
    /* border: 1px solid #f00; */
    width: 20px;
    height: 20px;
    color: #fff;
  }

  .flagBotBox1 {
    top: 385px;
    left: 0;
    transform: scale(1, 1);
    animation: doBotMove1 5s infinite linear;
  }

  .flagBotBox2 {
    top: 470px;
    left: 200px;
    transform: scale(1.2, 1.2);
    animation: doBotMove2 5s infinite linear;
  }

  .flagBotBox3 {
    top: 470px;
    left: 400px;
    transform: scale(1.2, 1.2);
    animation: doBotMove3 5s infinite linear;
  }

  .flagBotBox4 {
    top: 368px;
    left: 639px;
    transform: scale(1, 1);
    animation: doBotMove4 5s infinite linear;
  }

  .flagBotBox5 {
    top: 300px;
    left: 200px;
    transform: scale(0.8, 0.8);
  }

  .flagBotBox6 {
    top: 300px;
    left: 450px;
    transform: scale(0.8, 0.8);
  }

  @keyframes doBotMove1 {
    15% {
      top: 300px;
      left: 200px;
      transform: scale(0.8, 0.8);
    }

    30% {
      top: 300px;
      left: 450px;
      transform: scale(0.8, 0.8);
    }

    45% {
      top: 368px;
      left: 639px;
      transform: scale(1, 1);
    }

    60% {
      top: 470px;
      left: 400px;
      transform: scale(1.2, 1.2);
    }

    75% {
      top: 470px;
      left: 200px;
      transform: scale(1.2, 1.2);
    }

    100% {
      top: 385px;
      left: 0;
      transform: scale(1, 1);
    }
  }

  @keyframes doBotMove2 {
    15% {
      top: 385px;
      left: 0;
      transform: scale(1, 1);
    }

    30% {
      top: 300px;
      left: 200px;
      transform: scale(0.8, 0.8);
    }

    45% {
      top: 300px;
      left: 450px;
      transform: scale(0.8, 0.8);
    }

    60% {
      top: 368px;
      left: 639px;
      transform: scale(1, 1);
    }

    75% {
      top: 470px;
      left: 400px;
      transform: scale(1.2, 1.2);
    }

    100% {
      top: 470px;
      left: 200px;
      transform: scale(1.2, 1.2);
    }
  }

  @keyframes doBotMove3 {
    15% {
      top: 470px;
      left: 200px;
      transform: scale(1.2, 1.2);
    }

    30% {
      top: 385px;
      left: 0;
      transform: scale(1, 1);
    }

    45% {
      top: 300px;
      left: 200px;
      transform: scale(0.8, 0.8);
    }

    60% {
      top: 300px;
      left: 450px;
      transform: scale(0.8, 0.8);
    }

    75% {
      top: 368px;
      left: 639px;
      transform: scale(1, 1);
    }

    100% {
      top: 470px;
      left: 400px;
      transform: scale(1.2, 1.2);
    }
  }

  @keyframes doBotMove4 {
    15% {
      top: 470px;
      left: 400px;
      transform: scale(1.2, 1.2);
    }

    30% {
      top: 470px;
      left: 200px;
      transform: scale(1.2, 1.2);
    }

    45% {
      top: 385px;
      left: 0;
      transform: scale(1, 1);
    }

    60% {
      top: 300px;
      left: 200px;
      transform: scale(0.8, 0.8);
    }

    75% {
      top: 300px;
      left: 450px;
      transform: scale(0.8, 0.8);
    }

    100% {
      top: 368px;
      left: 639px;
      transform: scale(1, 1);
    }
  }

  .moreTipBtn {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #516381;
    cursor: pointer;
    position: absolute;
    right: -80px;
  }

  .newsInfo {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #516381;
    line-height: 23px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }

  .polTime {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #516381;
    line-height: 26px;
    margin-top: 33px;
  }

  .polInfo {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #516381;
    line-height: 27px;
    margin-top: 10px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;

  }

  .polBlockTit {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #121E30;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
  }

  .yyOutWrap {
    /* border: 1px solid #f00; */
    height: 300px;
    position: relative;
    width: 787px;
    overflow: hidden;
  }

  /**/
  .mySlide {
    width: 260px;
    height: 300px;
    /* border: 1px solid #000; */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 20px 0;
  }


  .serWrap {
    position: relative;
    width: 1373px;
    margin: 124px auto 0;
    display: flex;
    justify-content: space-around;
  }

  .serviceLeft {
    /* border: 1px solid #f00; */
    width: 550px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .serBlock {
    display: inline-block;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 160px;
    margin: 50px;
    cursor: pointer;
  }

  .serBlock:hover {
    /* transform: scale(1.2,1.2); */
  }

  .serIcon {
    height: 73px;
    margin-bottom: 20px;
  }

  .serText {
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
  }

  .serviceRight .rImg {
    width: 808px;
  }

  .safe {
    width: 100%;
    height: 840px;
    box-sizing: border-box;
    padding-top: 60px;
  }

  .safeTit {
    font-size: 40px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    padding-top: 102px;
    margin-bottom: 103px;
  }

  .safeLeft {
    width: 436px;
    height: 500px;
    /* border: 1px solid #f00; */
    position: relative;
  }

  .safeDun {
    width: 280px;
    margin-left: 78px;
    position: relative;
    z-index: 2;
  }

  .safeYing {
    width: 200px;
    /* border: 1px solid #f00; */
    position: absolute;
    top: 300px;
    left: 50%;
    margin-left: -100px;
  }

  .dunAni {
    animation: dunAnimation 2s linear infinite;
  }

  .yingAni {
    animation: yingAnimation 2s linear infinite;
  }

  .safeDi {
    width: 436px;
    height: 217px;
    position: absolute;
    top: 250px;
    left: 0;
    z-index: 1;
  }

  .safeWrap {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  @keyframes dunAnimation {
    0% {
      margin-top: 0;
    }

    50% {
      margin-top: -30px;
    }

    100% {
      margin-top: 0;
    }
  }

  @keyframes yingAnimation {
    0% {
      transform: scale(1, 1)
    }

    50% {
      transform: scale(0.6, 0.6)
    }

    100% {
      transform: scale(1, 1)
    }
  }

  .safeRight {
    width: 695px;
    /* border: 1px solid #f00; */
  }

  .safeRight p {
    margin: 59px 0 104px;
    padding: 0;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
  }

  .safeItem {
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid #F0F5FF;
    display: inline-block;
    padding: 10px 23px;
    margin-right: 20px;
    margin-bottom: 40px;
  }

  .safeItem img {
    width: 26px;
    margin-right: 18px;
    vertical-align: middle
  }

  .safeItem span {
    font-size: 22px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    vertical-align: middle;
  }

  .zcInformation {
    width: 100%;
    height: 840px;
    box-sizing: border-box;
    background: url('../assets/images/dtbj@2x.png') top left no-repeat;
    background-size: 100% 100%;
  }

  .zcInner {
    width: 1300px;
    margin: 0 auto;
    /* border: 1px solid #f00; */
  }

  .zcTit {
    font-size: 40px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #121E30;
    padding: 88px 0 70px;
    text-align: center;
  }

  .zcWrap {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
  }

  .zcInfoBox {
    width: 45%;
    /* border: 1px solid #f00; */
  }

  .zcWrap .zcInfoBox:nth-child(1) {
    margin-right: 68px;
  }

  .zcInfoBox .topInfo {
    font-size: 26px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #121E30;
    position: relative;
    vertical-align: middle;
    margin-bottom: 20px;
    padding-left: 15px;
  }

  .zcInfoBox .topInfo1::after {
    content: "";
    display: block;
    width: 4px;
    height: 24px;
    background: #0F5EFF;
    border-radius: 1px;
    position: absolute;
    left: 0;
    top: 6px;
  }

  .zcInfoBox .topInfo2::after {
    content: "";
    display: block;
    width: 4px;
    height: 24px;
    background: #0FBEFF;
    border-radius: 1px;
    position: absolute;
    left: 0;
    top: 6px;
  }

  .zcInfoBox .topInfo span {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #516381;
    float: right;
    vertical-align: middle;
    line-height: 50px;
    cursor: pointer;
  }

  .zcInfoBox .topInfo span img {
    vertical-align: middle;
    width: 12px;
    height: 12px;
    margin-left: 5px;
  }

  .zcInfoBox .topImgBox {
    width: 100%;
    height: 222px;
    background: url('../assets/images/safeBg.png');
    background-position: center top;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 10px;
    position: relative;
    margin-bottom: 10px;
    overflow: hidden;
  }

  .topImgBar {
    height: 42px;
    background: rgba(0, 0, 0, 0.4);
    line-height: 42px;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
    box-sizing: border-box;
    padding: 0 18px 0 25px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    cursor: pointer;
  }

  .topImgBar .time {
    float: right;
    color: #CCD3DF;
  }

  .zcInfoList .infoItem {
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    border-bottom: 1px solid #CBD3E9;
    position: relative;
    margin-left: 20px;
    padding-right: 15px;
    padding-bottom: 10px;
    padding-top: 10px;
    cursor: pointer;
  }

  .zcInfoBox .lineText {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    /* border: 1px solid #f00; */
    width: 70%;
    display: inline-block;
  }

  .zcInfoList .infoItem::after {
    content: "";
    display: block;
    width: 4px;
    height: 11px;
    background: #CBD3E9;
    border-radius: 1px;
    position: absolute;
    left: -20px;
    top: 20px;
  }

  .zcInfoList .infoItem .time {
    float: right;
  }

  .moreApp {
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #0F5EFF;
    text-align: left;
    padding: 20px 0 20px 20px;
    cursor: pointer;
  }

  .iotWrap {
    width: 100%;
    height: 840px;
    background: url('../assets/images/iot_bj@2x.png') top center no-repeat;
  }

  .iotInnerWrap {
    width: 1300px;
    margin: 0 auto;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .iotTit {
    font-size: 40px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    padding-top: 108px;
    padding-bottom: 96px;
  }

  .iotLeft {
    flex: 1;
    padding-right: 100px;
    box-sizing: border-box;
  }

  .iotLeft>div {
    margin-bottom: 25px;
  }

  .iotLeft .cirIcon {
    width: 10px;
    height: 10px;
    margin-right: 18px;
    vertical-align: middle;
  }

  .iotLeft span {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 36px;
    vertical-align: middle;
  }

  .iotLeft em {
    font-style: normal;
    display: block;
    padding-left: 30px;
    font-size: 16px;
  }

  .iotLeft em b {
    font-weight: normal;
    color: #0c67d8;
    margin-right: 10px;
    font-size: 14px;
  }

  .iotRight {
    width: 650px;
    height: 515px;
    background: url('../assets/images/iot_right@2x.png') top center no-repeat;
    background-size: 100% 100%;
    position: relative;
  }

  .iotRight .name {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #66F4FF;
    position: absolute;
  }

  .iotRight .line {
    display: block;
    height: 46px;
    width: 1px;
    border-left: 1px dashed rgba(102, 244, 255, 1);
    position: absolute;
    animation: upAnimate 3s infinite linear;
  }

  .iotRight .name.active {
    animation: showName 1s infinite 1
  }

  .iotRight .line.active {
    animation: upAnimate 3s infinite 1
  }

  @keyframes showName {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes upAnimate {
    0% {
      height: 0;
    }

    30% {
      height: 0;
    }

    100% {
      height: 46px;
    }
  }

  .iotRight .name0 {
    top: 200px;
    left: 48px;
  }

  .iotRight .line0 {
    left: 72px;
    bottom: 263px;
  }

  .iotRight .name1 {
    top: 76px;
    right: 68px;
  }

  .iotRight .line1 {
    right: 99px;
    bottom: 363px;
  }

  .iotRight .name2 {
    top: 352px;
    left: 24px;
  }

  .iotRight .line2 {
    bottom: 96px;
    left: 40px;
  }

  .iotRight .name3 {
    top: 369px;
    left: 216px;
  }

  .iotRight .line3 {
    left: 236px;
    bottom: 79px
  }

  .iotRight .name4 {
    left: 367px;
    top: 415px;
  }

  .iotRight .line4 {
    left: 407px;
    bottom: 34px;
  }

  .iotRight .name5 {
    top: 308px;
    left: 524px;
  }

  .iotRight .line5 {
    left: 553px;
    bottom: 140px;
  }

  .handleWrap {
    background: linear-gradient(183deg, #FFFFFF, #F2F7FF);
  }

  .platTit {
    color: rgba(18, 30, 48, 1);
  }

  .faldList {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .faldList_item {
    width: 30%;
    height: 130px;
    background: #FFFFFF;
    box-shadow: 4px 6px 18px 0px #EFF2FA;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 26px;
    color: #1E1E1E;
    cursor: pointer;
  }

  .faldList_item1 {
    color: #FFFFFF;
    background: #002071;
    box-shadow: 4px 6px 18px 0px #EFF2FA;
    border-radius: 20px;

    width: 30%;
    height: 130px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 26px;
    cursor: pointer;
  }

  .facontent {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 100px;
    box-sizing: border-box;
    padding: 0 60px;
  }

  .sbzt {
    width: 420px;
    /* height: 362px; */
    margin-right: 50px;
  }

  .fatitle {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 36px;
    color: #1E1E1E;
  }

  .fainfo {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #1E1E1E;
    line-height: 32px;
    margin: 40px 0;
  }

  .fabtns {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .fabtns>div:first-child {
    width: 150px;
    height: 52px;
    border-radius: 10px;
    border: 1px solid #002071;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 18px;
    color: #0A2979;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    cursor: pointer;
  }

  .fabtns>div:last-child {

    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    height: 52px;
    background: #0A2979;
    border-radius: 10px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 18px;
    color: #FFFFFF;
    cursor: pointer;
  }

  .sc_icon {
    width: 328px;
    height: 520px;
  }

  .sccontent {
    width: 990px;
    height: 520px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }

  .sccontent>div {
    width: 33.2%;
    height: 33.3%;
    /* border-right: 1px solid #EEF1F8; */
    border-bottom: 1px solid #EEF1F8;
    background: #FFFFFF;
    box-sizing: border-box;
    padding: 27px 36px;
  }

  .sctitle {
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .sctitle>img {
    width: 38px;
    height: 38px;
    margin-right: 10px;
  }

  .sctitle>div {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #1E1E1E;
  }

  .scinfo {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 16px;
    color: #858FA8;
    margin: 25px 10px 25px 0;
    display: inline-block;
  }

  .scdetails {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #002071;
    cursor: pointer;
  }

  .qysjd {
    width: 150px;
    height: 52px;
    border-radius: 10px;
    border: 1px solid #002071;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 18px;
    color: #0A2979;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    cursor: pointer;
  }

  .safetitle {
    text-align: center;
    margin: 0 auto 60px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 48px;
    color: #1E1E1E;
  }

  .gyTit {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 48px;
    color: #1E1E1E;
    text-align: center;
  }

  .gycontent {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 18px;
    color: #1E1E1E;
    line-height: 40px;
  }

  .gywmbg {
    height: 181px;
    margin: 40px 0 20px;
  }

  .gycontent1 {
    width: 1318px;
    height: 341px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: url('../assets/images/gywmbg1.png') top center no-repeat;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 30px 60px;
  }

  .gycontent1>div>div {
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #1E1E1E;
    line-height: 24px;
    position: relative;
    margin-top: 15px;
  }

  .gycontent1>div>div::before {
    content: ' ';
    position: absolute;
    top: 5px;
    left: -25px;
    width: 2px;
    height: 15px;
    background: #0A2979;
  }

  .gywmright {
    min-width: 237px;
    width: 237px;
    height: 237px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 70px;
  }

  .glogo {
    width: 198px;
    height: 106px;
  }

  .moreCP {
    width: 150px;
    height: 52px;
    border-radius: 10px;
    border: 1px solid #002071;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 18px;
    color: #0A2979;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 35px auto 0;
    cursor: pointer;
  }


</style>



// WEBPACK FOOTER //
// src/views/Home.vue